import { LoginAction } from './actions';
import ActionType, { SigninErrorState, TextFieldStatus } from './types';

interface SigninFieldValue {
  value: string;
  status: TextFieldStatus;
}

type SigninStatus =
  | 'not_signin'
  | 'signin_loading'
  | 'signin'
  | SigninErrorState;

export interface SigninState {
  status: SigninStatus;
  identifyValue: SigninFieldValue;
  password: SigninFieldValue;
}

export const initialState: () => SigninState = () => {
  return {
    status: 'not_signin',
    identifyValue: {
      value: '',
      status: 'empty'
    },
    password: {
      value: '',
      status: 'empty'
    }
  };
};

const reducer = (
  state: SigninState = initialState(),
  action: LoginAction
): SigninState => {
  switch (action.type) {
    case ActionType.updateSigninIdentifyValue: {
      return {
        ...state,
        status: 'not_signin',
        identifyValue: { value: action.payload, status: 'valid' }
      };
    }
    case ActionType.validateSigninIdentifyValue: {
      return {
        ...state,
        identifyValue: { ...state.identifyValue, status: action.payload }
      };
    }
    case ActionType.updateSigninPassword: {
      return {
        ...state,
        status: 'not_signin',
        password: { value: action.payload, status: 'valid' }
      };
    }
    case ActionType.validateSigninPassword: {
      return {
        ...state,
        password: { ...state.password, status: action.payload }
      };
    }
    case ActionType.startToSignin: {
      const newState = { ...state };
      newState.status = 'signin_loading';
      return newState;
    }
    case ActionType.signinSuccess: {
      const newState = { ...state };
      newState.status = 'signin';
      return newState;
    }
    case ActionType.signinFailed: {
      const newState = { ...state };
      newState.status = action.payload;
      return newState;
    }
    case ActionType.clearSigninStatus: {
      return initialState();
    }
    default:
      ((_: never) => {
        return;
      })(action);
      return state;
  }
};

export default reducer;
